import type { API_ERROR_CODE } from './api-error-messages/ApiErrorMessages';

export type ApiErrorData<T = undefined> = {
  code: number;
  data: {
    client_code: API_ERROR_CODE;
    data: T;
  };
  message: string;
  stack: string;
};

export class ApiError<T = undefined> implements ApiErrorData<T> {
  code: number;
  data: {
    client_code: API_ERROR_CODE;
    data: T;
  };
  message: string;
  stack: string;
  constructor(data: ApiErrorData<T>) {
    this.code = data.code;
    this.data = data.data;
    this.message = data.message;
    this.stack = data.stack;
  }
}

// for v2 error handler
